import styled from 'styled-components';

import { atMinWidth } from '../../../atoms/breakpoints';
import { color } from '../../../atoms/colors';
import { containers } from '../../../atoms/containers';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';

import {
  defaultStyles,
  sizes,
  variants,
} from '../../CallToAction/styles/theme.styled';

export const Container = styled.div`
  width: 100%;
  padding: ${spacing[16]} ${spacing[0]} ${spacing[24]};
  z-index: 11;
  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  ${atMinWidth.lg`
    padding: ${spacing[4]} ${spacing[0]} ${spacing[24]};
  `}

  ${atMinWidth.xl`
    position: sticky;
    top: 80px;
    padding-bottom: ${spacing[24]};
    
    &.scrolled {
      background-color: ${color.common.white};
      box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);
    }
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${containers.md};
  display: flex;
  flex-direction: column;
  gap: ${spacing[8]};
  padding: ${spacing[0]} ${spacing[16]};
  margin: ${spacing[0]} auto;

  ${atMinWidth.lg`
    padding: ${spacing[0]} ${spacing[32]};
  `}

  ${atMinWidth.xl`
    max-width: ${containers.xl};
    padding: ${spacing[0]} ${spacing[32]};
  `};
`;

export const Text = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  gap: ${spacing[16]};

  .mobile-filter-btn {
    ${defaultStyles}
    ${variants['Outline Dark - Transparent']}
    ${sizes.md}

    ${atMinWidth.xl`
      display: none;
    `}

    .filter-count {
      width: ${spacing[24]};
      height: ${spacing[24]};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: ${spacing[32]};
      border-radius: ${spacing[56]};
      background: ${color.blue[50]};
      ${font('text', 'xs', '400')}
      color: ${color.darkBlue[600]};
    }
  }

  .label {
    display: none;
    ${font('text', 'md', '400')}
    color: ${color.darkBlue[1000]};

    ${atMinWidth.xl`
      display: block;
    `}
  }

  .count {
    ${font('text', 'sm', '400')}
    color: ${color.darkBlue[1000]};

    b {
      ${font('text', 'sm', '700')}
    }
  }
`;

export const CategoryFilters = styled.div`
  display: none;

  ${atMinWidth.xl`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: padding 0.2s ease-in-out, border-bottom 0.2s ease-in-out;
    padding-bottom: ${spacing[24]};
    border-bottom: 1px solid ${color.darkBlue[50]};

    &.scrolled {
      border-bottom: 1px solid ${color.common.transparent};
      padding-bottom: ${spacing[0]};
    }
  `}

  #defaultSearchBar {
    max-width: 280px;
    margin: 0px;
  }
`;
